export enum ReportName {
    DashboardRmc = 'dashboard-rmc',
    DashboardRmcLegacy = 'dashboard-rmc-legacy',
}
